import { Component } from '@angular/core';
import { Skeleton } from 'excellence-ui';

@Component({
  selector: 'app-supplier-contract-card-skeleton',
  imports: [Skeleton],
  templateUrl: './supplier-contract-card-skeleton.html',
})
export class SupplierContractCardSkeleton {}
